import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { setupIconFontFallback } from './lib/iconCdnFallback'

// 启动时挂上图标字体 CDN 回退：主 CDN 失效时自动切换备用源，避免整站图标一起消失。
setupIconFontFallback()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)